import React, { useContext } from "react";
import classes from "./MapLocationInfo.module.scss";
import GoalContext from "../../store/goal-context";
import colourClasses from "../../colour.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'

const MapLocationInfo = () => {
  const goalContext = useContext(GoalContext);
  let activeLocation = null;
  let activeColour = null;
  let goalColour = null;

  if (goalContext.activeLocation !== null && goalContext.activeGoal !== null) {
      goalColour = goalContext.goals[goalContext.activeGoal - 1].primary_colour;
      activeColour = goalColour ? `colour--${goalColour}` : "colour--black";
      activeLocation = goalContext.goals[goalContext.activeGoal - 1].locations[goalContext.activeLocation];
  }

  const scrollToTop = () => {
    const anchor = document.querySelector('#goal-header');
    anchor.scrollIntoView({
        behavior: 'smooth'
    });
};

  return (
    <>
      {activeLocation && (
        <div className={`${classes.mapLocationInfo} ${colourClasses[activeColour]}`}>
          <div className={classes["active-location"]}>
            <h3>{activeLocation.name}</h3>
            <p>{activeLocation.description}</p>
            {
                activeLocation.link && 
                <div className={classes["website"]}><a href={activeLocation.link}>Visit Website <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a></div>
            }
            <button className={`${classes['up-to-listing']} ${colourClasses[activeColour]}`} onClick={scrollToTop}>
                <div className={classes.text}>Up to listing</div>
            </button>  
          </div>
        </div>
      )}
    </>
  );
};

export default MapLocationInfo;
